import * as React from "react";
import { UitkHeading, UitkIcon, UitkLink, UitkText, classNames } from "../index.js";
export var UitkCalloutCardTheme = /* @__PURE__ */ ((UitkCalloutCardTheme2) => {
  UitkCalloutCardTheme2["success"] = "success";
  UitkCalloutCardTheme2["warning"] = "warning";
  UitkCalloutCardTheme2["info"] = "info";
  UitkCalloutCardTheme2["error"] = "error";
  return UitkCalloutCardTheme2;
})(UitkCalloutCardTheme || {});
export var UitkCalloutCardActionTypes = /* @__PURE__ */ ((UitkCalloutCardActionTypes2) => {
  UitkCalloutCardActionTypes2["close"] = "close";
  UitkCalloutCardActionTypes2["navigate"] = "nav";
  return UitkCalloutCardActionTypes2;
})(UitkCalloutCardActionTypes || {});
export function UitkCalloutCard({
  theme = "info" /* info */,
  headingText,
  textValue,
  link,
  action,
  onClickAction,
  className,
  style
}) {
  const actionIcon = action == "close" /* close */ ? "close" : "chevron_right";
  const isClickableCard = action === "nav" /* navigate */ && typeof link != "object";
  const globalTheme = isClickableCard ? `uitk-card-messaging uitk-card-messaging-${theme} callout uitk-card-messaging-clickable` : `uitk-card-messaging uitk-card-messaging-${theme} callout`;
  const iconName = theme === "success" ? "check_circle" : theme;
  const iconTheme = `icon-theme-${theme}`;
  return /* @__PURE__ */ React.createElement("div", { className: classNames(globalTheme, className), style, onClick: isClickableCard && onClickAction || void 0 }, /* @__PURE__ */ React.createElement("div", { className: "flex" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkIcon, { name: iconName, className: iconTheme })), /* @__PURE__ */ React.createElement("div", { className: "center" }, /* @__PURE__ */ React.createElement("div", { className: "text" }, /* @__PURE__ */ React.createElement(UitkHeading, { size: 7, tag: "h3" }, headingText), /* @__PURE__ */ React.createElement(UitkText, { size: 300, className: "uitk-type-300" }, textValue)), link && /* @__PURE__ */ React.createElement("div", { className: "links" }, /* @__PURE__ */ React.createElement(
    UitkLink,
    {
      align: "right",
      inline: true,
      noWrap: false,
      size: "medium",
      theme: "default",
      className: "uitk-link-layout-inline-no-decoration"
    },
    /* @__PURE__ */ React.createElement("span", null, link)
  ))), action && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: classNames("action", action), onClick: !isClickableCard && onClickAction || void 0 }, /* @__PURE__ */ React.createElement(UitkIcon, { name: actionIcon, className: "icon-theme-action" })))));
}
;
